;
(function ($, window, document, undefined) {

    "use strict";

    // undefined is used here as the undefined global variable in ECMAScript 3 is
    // mutable (ie. it can be changed by someone else). undefined isn't really being
    // passed in so we can ensure the value of it is truly undefined. In ES5, undefined
    // can no longer be modified.

    // window and document are passed through as local variables rather than global
    // as this (slightly) quickens the resolution process and can be more efficiently
    // minified (especially when both are regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = "onyxPlayer",
            defaults = {
            };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;

        // jQuery has an extend method which merges the contents of two or
        // more objects, storing the result in the first object. The first object
        // is generally empty as we don't want to alter the default options for
        // future instances of the plugin
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.video = $('video', this.element).get(0);
        this.pauseButton = $('.play', this.element);

        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {

            // Place initialization logic here
            // You already have access to the DOM element and
            // the options via the instance, e.g. this.element
            // and this.settings
            // you can add more functions like the one below and
            // call them like the example below

            var vid = this.video;
            var element = this.element;

            function vidFade() {
                this.video.classList.add("stopfade");
            }

            this.video.addEventListener('ended', function ()
            {
                // only functional if "loop" is removed 
                this.video.pause();
                // to capture IE10
                vidFade();
            });

            this.pauseButton.on("click", function (e) {
                e.preventDefault();

                vid.classList.toggle("stopfade");
                if (vid.paused) {
                    vid.play();
                    $(element).addClass('plaing');
                } else {
                    vid.pause();
                    $(element).removeClass('plaing');
                }
            });
        }
    });

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[ pluginName ] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                        pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);



(function ($) {
    $('.onyx-video-player').onyxPlayer();
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/vendor/onyx-video-player.js